import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TabPanel, TabView } from 'primereact/tabview';
import { InputComponent } from '../../../../../components/InputComponent';
import { CatalogoService } from '../../../../../service/CatalogoService';
import * as generic from '../../../../../components/Generico';
import { CertificacionPj } from '../../../../../models/trust/cliente/CertificacionPj';
import { PjService } from '../../../../../service/trust/certificacion/PjService';
import { PaisFiscal } from '../../../../../components/trust/PaisFiscal';
import { Certificacion } from '../../clientePn/Certificacion';
import { Divider } from 'primereact/divider';
import { ControlPersona } from '../../../../../components/trust/ControlPersona';
import { confirmDialog } from 'primereact/confirmdialog';
import { PnService } from '../../../../../service/trust/certificacion/PnService';
import { useSubmitForm } from '../../../../../hooks/useSubmitForm';
import { AnexosComponent } from '../../../../../components/AnexosComponent';
import { Message } from 'primereact/message';

export const CertificacionSociedad = ({ toast, id, permss, catalogos, handlePrev, soloLectura, siCliente, onCertificacionEnviada }) => {

    const omodel = new CertificacionPj();
    const defaultValues = generic.funDefault(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const pjSrv = new PjService();
    const pnSrv = new PnService();
    const catalogoService = new CatalogoService();
    const [estadoCertificadoPj, setEstadoCertificadoPj] = useState(null);
    const isReadOnly = soloLectura || estadoCertificadoPj === 'FINALIZADO';
    const { inText, inDrop, inCalendar } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura: isReadOnly });
    const { enviarFormulario, dialogAnexo, setDialogAnexo, anexoPendientes } = useSubmitForm({
        toast, setError, onSuccess: (res) => {
            // Atrapamos la respuesta del backend y actualizamos el estado de la vista
            if (res?.data?.estado) {
                setEstadoCertificadoPj(res.data.estado);
                const envioExitoso = ['ENVIADO'].includes(res.data.estado);
                if (envioExitoso && onCertificacionEnviada) {
                    onCertificacionEnviada(); // Avisamos al Padre
                }
            }
        }
    });

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuadorLegal, setEcuadorLegal] = useState(false);
    const [ciudadesLegal, setCiudadesLegal] = useState([]);
    const [ecuadorPostal, setEcuadorPostal] = useState(false);
    const [ciudadesPostal, setCiudadesPostal] = useState([]);
    const [esEeuu, setEsEeuu] = useState(false);
    const [esExtranjero, setEsExtranjero] = useState(false);
    const [certId, setCertId] = useState(null);
    const [dialogControl, setDialogControl] = useState(false);
    const botonesInferioresRef = useRef(null);
    const [mostrarNavFlotante, setMostrarNavFlotante] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [tipo, setTipo] = useState(null);
    // Para los auto-certificados
    const [esInversion, setEsInversion] = useState(false);
    const [esCustodia, setEsCustodia] = useState(false);
    const [esCotizaBolsa, setEsCotizaBolsa] = useState(false);
    const [esPasiva, setEsPasiva] = useState(false);
    const [estadoCertificadoControl, setEstadoCertificadoControl] = useState({
        inversion: null,
        deposito: null,
        pasiva: null
    });

    const urlsAnexos = {
        urlListado: 'ficha/trust/certificacion-pj',
        urlUpload: 'ficha/trust/certificacion-pj/store',
        urlDownload: 'ficha/trust/certificacion-pj/descarga',
        uaprobar: 'ficha/trust/certificacion-pj/aprobar',
        udelete: 'ficha/trust/certificacion-pj/eliminar-anexo',
    };

    useEffect(() => {
        if (id) editFicha();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => { if (!isLoading) setMostrarNavFlotante(!entry.isIntersecting); },
            { threshold: 0 }
        );
        const currentRef = botonesInferioresRef.current;
        if (currentRef) observer.observe(currentRef);
        return () => { if (currentRef) observer.unobserve(currentRef); };
    }, [isLoading, activeIndex]);

    const editFicha = () => {
        setIsLoading(true);
        pjSrv.consultar(id).then(res => {
            const _data = res.data.certificacion;
            if (!_data) { // Si no hay datos, limpiamos el formulario y salimos
                reset(defaultValues);
                return;
            }
            setEstadoCertificadoPj(_data.estado);
            const isEcLegal = _data.pais_legal?.cat_id === catalogos?.ecuador?.cat_id;
            const isEcPostal = _data.pais_postal?.cat_id === catalogos?.ecuador?.cat_id;
            setEcuadorLegal(isEcLegal);
            setEcuadorPostal(isEcPostal);
            if (isEcLegal && res.data.ciudadesLegal) setCiudadesLegal(res.data.ciudadesLegal);
            if (isEcPostal && res.data.ciudadesPostal) setCiudadesPostal(res.data.ciudadesPostal);

            _data.fecha = generic.stringToDate(_data.fecha);

            setCertId(_data.id ?? null);

            setEsCotizaBolsa(_data.entidad_cotiza_bolsa?.cat_id === true);
            setEsEeuu(_data.eeuu_fin_fiscal?.cat_id === true);
            setEsExtranjero(_data.extranjero_fin_fiscal?.cat_id === true);
            setEsInversion(_data.institucion_inversion?.cat_id === true);
            setEsCustodia(_data.entidad_custodia?.cat_id === true);
            setEsPasiva(_data.entidad_pasiva?.cat_id === true);
            if (res.data.estados_control) {
                setEstadoCertificadoControl(res.data.estados_control);
            }
            reset(generic.renewValues(_data, omodel.model));
        }).finally(() => setIsLoading(false));
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.idp = id;
        data.fecha = generic.dateToString(data.fecha);
        data.ec = catalogos?.ecuador;
        data.seccion = "seccion" + (activeIndex + 1);

        const request = getValues('id') == null ? pjSrv.nuevo(data) : pjSrv.editar(data);
        request.then(res => {
            if (res.data?.codigo) {
                setCertId(res.data.codigo);
                setValue('id', res.data.codigo);
            }
            if (res.data?.estado) { // Capturamos el estado en la primera creación para poder subir anexos
                setEstadoCertificadoPj(res.data.estado);
            }
            generic.funcSuccess(res, toast);
            setActiveIndex(1);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    };

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    };

    const handleNextSeccion = () => setActiveIndex(1);
    const handlePrevSeccion = () => setActiveIndex(0);

    const onChangePais = (e, tipo) => {
        const isEc = e.value?.cat_id === catalogos?.ecuador?.cat_id;
        if (tipo === 'legal') {
            setEcuadorLegal(isEc);
            setValue('provincia_legal', null);
            setValue('ciudad_legal', null);
            setValue('canton_legal', '');
            setCiudadesLegal([]);
        } else if (tipo === 'postal') {
            setEcuadorPostal(isEc);
            setValue('provincia_postal', null);
            setValue('ciudad_postal', null);
            setValue('canton_postal', '');
            setCiudadesPostal([]);
        }
    };

    const onChangeProvincia = (e, tipo) => {
        if (tipo === 'legal') {
            setValue('ciudad_legal', null);
            if (!e?.value) { setCiudadesLegal([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesLegal(res.data));
        } else {
            setValue('ciudad_postal', null);
            if (!e?.value) { setCiudadesPostal([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesPostal(res.data));
        }
    };

    const onChangeCotizaBolsa = (e) => {
        const value = e.value?.cat_id === true;
        setEsCotizaBolsa(value);
        if (!value) setValue('nombre_mercado', '');
    };

    const onChangeEeuu = (e) => {
        const value = e.value?.cat_id === true;
        setEsEeuu(value);
        if (!value) setValue('eeuu_identificacion', '');
    };

    const onChangeExtranjero = (e) => setEsExtranjero(e.value?.cat_id === true);

    const onChangeControl = (campo) => (e) => {
        // Verificamos si la respuesta seleccionada es "SI" (true)
        const isYes = e.value?.cat_id === true;

        // Actualizamos el estado correspondiente para mostrar/ocultar el botón
        if (campo === 'institucion_inversion') setEsInversion(isYes);
        if (campo === 'entidad_custodia') setEsCustodia(isYes);
        if (campo === 'entidad_pasiva') setEsPasiva(isYes);
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    const generarReporte = () => {
        setLoadReport(true);
        pjSrv.descargar(certId).then(res => {
            generic.downloadPdf(res, 'Autocertificacion-Sociedad.pdf');
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    };

    const subirReporte = () => {
        setDialogAnexo(true);
    };

    const enviar = () => {
        enviarFormulario(certId, 'ficha/trust/certificacion-pj/enviar', 'certificacionPj');
    };

    const renderActionForm = (tipo) => {
        const estadoHijo = estadoCertificadoControl[tipo]; // Puede ser null, 'BORRADOR', 'ENVIADO', 'FINALIZADO'

        // Configuración visual del texto y colores
        let textoBadge = "Pendiente de completar";
        let colorIcono = "text-blue-500";
        let colorFondo = "bg-blue-50 border-blue-200";

        if (estadoHijo === 'BORRADOR') {
            textoBadge = "En Borrador";
            colorIcono = "text-yellow-600";
            colorFondo = "bg-yellow-50 border-yellow-200";
        } else if (estadoHijo === 'ENVIADO') {
            textoBadge = "Enviado";
            colorIcono = "text-indigo-500";
            colorFondo = "bg-indigo-50 border-indigo-200";
        } else if (estadoHijo === 'FINALIZADO') {
            textoBadge = "Finalizado";
            colorIcono = "text-green-600";
            colorFondo = "bg-green-50 border-green-200";
        }

        return (
            <div className="flex w-full shadow-1 border-round" style={{ height: '32.2px', overflow: 'hidden' }}>
                <div className={`flex align-items-center ${colorFondo} border-1 px-3 flex-grow-1`} style={{ borderRight: 'none' }}>
                    <i className={`pi pi-info-circle mr-2 text-base ${colorIcono}`}></i>
                    <span className="text-sm font-medium text-800 line-height-1">
                        Formulario auto-certificación ({textoBadge})
                    </span>
                </div>

                {!estadoHijo && permss?.crear && !isReadOnly && (
                    <Button label="Completar" icon="pi pi-pencil" type="button" onClick={() => mostrarControl(tipo, estadoHijo)} className="p-button-primary p-button-sm m-0" style={{ borderRadius: '0', height: '100%', padding: '0 1rem' }} />
                )}

                {estadoHijo === 'BORRADOR' && permss?.actualizar && !isReadOnly && (
                    <Button label="Continuar" icon="pi pi-pencil" type="button" onClick={() => mostrarControl(tipo, estadoHijo)} className="p-button-warning p-button-sm m-0" style={{ borderRadius: '0', height: '100%', padding: '0 1rem', borderRight: '1px solid #d99c15' }} />
                )}

                {estadoHijo === 'BORRADOR' && permss?.eliminar && !isReadOnly && (
                    <Button icon="pi pi-trash" type="button" title="Eliminar borrador" onClick={() => eliminarCertificadoControl(tipo)} className="p-button-danger p-button-sm m-0" style={{ borderRadius: '0', height: '100%', width: '40px' }} />
                )}

                {((estadoHijo && isReadOnly) || (estadoHijo && (estadoHijo === 'ENVIADO' || estadoHijo === 'FINALIZADO') && permss?.consultar)) && (
                    <Button label="Ver detalle" icon="pi pi-eye" type="button" onClick={() => mostrarControl(tipo, estadoHijo)} className="p-button-info p-button-sm m-0" style={{ borderRadius: '0', height: '100%', padding: '0 1rem' }} />
                )}
            </div>
        );
    }

    const actualizarEstadoBoton = (tipoHijo, nuevoEstado) => {
        setEstadoCertificadoControl(prev => ({
            ...prev,
            [tipoHijo]: nuevoEstado
        }));
    };

    const eliminarCertificadoControl = (tipoControl) => {
        confirmDialog({
            message: '¿Está seguro de eliminar esta auto-certificación en estado borrador?',
            header: 'Confirmar Eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => {
                pnSrv.eliminar(certId, { tipo: tipoControl, idp: id }).then(res => {
                    actualizarEstadoBoton(tipoControl, null);
                    generic.funcSuccess(res, toast);
                }).catch(err => generic.funcDeleteError(err, toast));
            }
        });
    };

    const mostrarControl = (tipo, estadoActual) => {
        setTipo(tipo);
        setDialogControl(true);
    }

    // Condición de solo lectura
    const esSoloLectura = isReadOnly || estadoCertificadoControl[tipo] === 'FINALIZADO' || (siCliente && estadoCertificadoControl[tipo] === 'ENVIADO');

    return (
        <>
            {(isReadOnly && siCliente) && (
                <div className="mb-4">
                    <Message severity="warn" text="Esta Auto-certificación ya ha sido enviada y se encuentra en modo de Solo Lectura." className="w-full justify-content-start shadow-1 border-round-md" />
                </div>
            )}
            <h5 className="text-900 font-bold mb-3">FORMULARIO AUTO-CERTIFICACIÓN DE RESIDENCIA FISCAL PARA SOCIEDADES</h5>
            <form id="form-certificacion-sociedad" onSubmit={handleSubmit(onSubmit, onError)}>
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="form-tabview">
                    <TabPanel header="Sección 1" leftIcon="pi pi-id-card mr-2">

                        <Panel header={generic.renderPanelHeader('', 'INICIO', 'pi pi-info-circle')} className="panel-ficha shadow-1 mb-4">
                            <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                                {omodel.strAuto}
                            </div>
                        </Panel>

                        <Panel header={generic.renderPanelHeader('A', 'Identificación del Constituyente / Beneficiario', 'pi pi-building')} className="panel-ficha shadow-1 mb-4">
                            <div className="formgrid grid p-2 p-fluid">
                                {inCalendar('fecha', {}, 3)}
                                {inText('razon_social', { icon: 'pi pi-building' }, 6)}
                                {inDrop('pais_constitucion', catalogos?.pais, { lab: 'nombre' }, 3)}

                                <div className="col-12"><Divider className="my-2" /></div>

                                {inText('domicilio_legal', { icon: 'pi pi-map-marker' }, 12)}

                                {ecuadorLegal ? (
                                    <>
                                        {inDrop('pais_legal', catalogos?.pais, { lab: 'nombre', chn: (e) => onChangePais(e, 'legal') }, 3)}
                                        {inDrop('provincia_legal', catalogos?.provincias, { lab: 'nombre', chn: (e) => onChangeProvincia(e, 'legal') }, 3)}
                                        {inDrop('ciudad_legal', ciudadesLegal, { lab: 'nombre' }, 3)}
                                        {inText('codigo_postal_legal', { icon: 'pi pi-hashtag' }, 3)}
                                    </>
                                ) : (
                                    <>
                                        {inDrop('pais_legal', catalogos?.pais, { lab: 'nombre', chn: (e) => onChangePais(e, 'legal') }, 4)}
                                        {inText('canton_legal', { icon: 'pi pi-map-marker' }, 4)}
                                        {inText('codigo_postal_legal', { icon: 'pi pi-hashtag' }, 4)}
                                    </>
                                )}

                                <div className="col-12"><Divider className="my-2" /></div>

                                {inText('domicilio_postal', { icon: 'pi pi-envelope' }, 12)}

                                {ecuadorPostal ? (
                                    <>
                                        {inDrop('pais_postal', catalogos?.pais, { lab: 'nombre', chn: (e) => onChangePais(e, 'postal') }, 3)}
                                        {inDrop('provincia_postal', catalogos?.provincias, { lab: 'nombre', chn: (e) => onChangeProvincia(e, 'postal') }, 3)}
                                        {inDrop('ciudad_postal', ciudadesPostal, { lab: 'nombre' }, 3)}
                                        {inText('codigo_postal', { icon: 'pi pi-hashtag' }, 3)}
                                    </>
                                ) : (
                                    <>
                                        {inDrop('pais_postal', catalogos?.pais, { lab: 'nombre', chn: (e) => onChangePais(e, 'postal') }, 4)}
                                        {inText('canton_postal', { icon: 'pi pi-map-marker' }, 4)}
                                        {inText('codigo_postal', { icon: 'pi pi-hashtag' }, 4)}
                                    </>
                                )}
                            </div>
                        </Panel>

                        <div ref={botonesInferioresRef} className="relative flex justify-content-end align-items-center mt-4 mb-4 px-1" style={{ minHeight: '50px' }}>
                            {isReadOnly ? (
                                <Button label="Siguiente" icon="pi pi-chevron-right" iconPos="right" type="button" onClick={handleNextSeccion} className="p-button-primary px-4" style={{ width: 'auto' }} />
                            ) : (
                                <Button label={isSaving ? 'Guardando...' : 'Siguiente'} icon={isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-chevron-right'} iconPos="right" type="submit" loading={isSaving} className="p-button-primary px-4" style={{ width: 'auto' }} />
                            )}
                        </div>

                    </TabPanel>

                    <TabPanel header="Sección 2" leftIcon="pi pi-file-check mr-2" disabled={!certId}>

                        <Panel header={generic.renderPanelHeader('B', 'Persona que ejerce el control', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                            <div className="formgrid grid p-2">
                                {inDrop('institucion_inversion', generic.estadosSiNo, {
                                    lab: 'nombre', chn: onChangeControl('institucion_inversion'), ne: isReadOnly || estadoCertificadoControl.inversion !== null,
                                    helpText: estadoCertificadoControl.inversion !== null ? "No editable: Ya existe un formulario asociado." : null
                                }, 6)}
                                <div className="field col-6 flex flex-column justify-content-end">
                                    <label className="block mb-1">&nbsp;</label>
                                    {esInversion && renderActionForm('inversion')}
                                    {estadoCertificadoControl.inversion !== null && (
                                        <small className="block mt-1 invisible" style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>&nbsp;</small>
                                    )}
                                </div>

                                {inDrop('entidad_custodia', generic.estadosSiNo, {
                                    lab: 'nombre', chn: onChangeControl('entidad_custodia'), ne: isReadOnly || estadoCertificadoControl.deposito !== null,
                                    helpText: estadoCertificadoControl.deposito !== null ? "No editable: Ya existe un formulario asociado." : null
                                }, 6)}
                                <div className="field col-6 flex flex-column justify-content-end">
                                    <label className="block mb-1">&nbsp;</label>
                                    {esCustodia && renderActionForm('deposito')}
                                    {estadoCertificadoControl.deposito !== null && (
                                        <small className="block mt-1 invisible" style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>&nbsp;</small>
                                    )}
                                </div>

                                {inDrop('entidad_cotiza_bolsa', generic.estadosSiNo, { lab: 'nombre', chn: onChangeCotizaBolsa }, 6)}
                                {esCotizaBolsa ? (
                                    inText('nombre_mercado', { icon: 'pi pi-chart-line' }, 6)
                                ) : (
                                    <div className="field col-6"></div>
                                )}

                                <div className="col-12"><Divider className="my-2" /></div>

                                {inDrop('entidad_org', generic.estadosSiNo, { lab: 'nombre' }, 6)}
                                <div className="field col-6"></div>

                                {inDrop('entidad_pasiva', generic.estadosSiNo, {
                                    lab: 'nombre', chn: onChangeControl('entidad_pasiva'), ne: isReadOnly || estadoCertificadoControl.pasiva !== null,
                                    helpText: estadoCertificadoControl.pasiva !== null ? "No editable: Ya existe un formulario asociado." : null
                                }, 6)}
                                <div className="field col-6 flex flex-column justify-content-end">
                                    <label className="block mb-1">&nbsp;</label>
                                    {esPasiva && renderActionForm('pasiva')}
                                    {estadoCertificadoControl.pasiva !== null && (
                                        <small className="block mt-1 invisible" style={{ fontSize: '0.75rem', lineHeight: '1.2' }}>&nbsp;</small>
                                    )}
                                </div>

                            </div>
                            <div className="p-3 mb-4 surface-100 border-round border-1 border-300">
                                <p className="m-0 text-700">
                                    <i className="pi pi-info-circle mr-2 text-primary"></i>
                                    Indique el nombre(s) de la persona que ejerce el control sobre la sociedad titular del fideicomiso: por cada una de estas personas llene una <strong>auto-certificación de persona que ejerce el control</strong>.
                                </p>
                            </div>
                            <div className="p-2">
                                <ControlPersona toast={toast} id={certId} idp={id} catalogos={catalogos} permss={permss} soloLectura={isReadOnly} siCliente={siCliente} />
                            </div>
                        </Panel>


                        <Panel header={generic.renderPanelHeader('C', 'Residencia fiscal del Constituyente o Beneficiario', 'pi pi-flag')} className="panel-ficha shadow-1 mb-4">
                            <div className="formgrid grid p-2">
                                {inDrop('eeuu_fin_fiscal', generic.estadosSiNo, { lab: 'nombre', chn: onChangeEeuu }, 6)}
                                {esEeuu ? (
                                    inText('eeuu_identificacion', { icon: 'pi pi-id-card' }, 6)
                                ) : (
                                    <div className="col-6"></div> // Espacio vacío controlado para mantener la simetría
                                )}

                                <div className="col-12"><Divider className="my-2" /></div>

                                {inDrop('extranjero_fin_fiscal', generic.estadosSiNo, { lab: 'nombre', chn: onChangeExtranjero }, 6)}
                                <div className="col-6"></div>
                            </div>
                        </Panel>

                        {esExtranjero && certId && (
                            <Panel header={generic.renderPanelHeader('', 'Países de residencia fiscal en el extranjero', 'pi pi-globe')} className="panel-ficha shadow-1 mb-4">
                                <PaisFiscal toast={toast} id={certId} catalogos={catalogos} permss={permss} soloLectura={isReadOnly} tipo="juridica" />
                            </Panel>
                        )}

                        <Panel header={generic.renderPanelHeader('D', 'Certificación y compromiso', 'pi pi-file-check')} className="panel-ficha shadow-1 mb-4">
                            <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                                <div className="flex align-items-center gap-2 mb-3">
                                    <i className="pi pi-shield text-blue-600 text-lg"></i>
                                    <span className="font-bold text-blue-900">Declaración</span>
                                </div>
                                {omodel.strCertificacion}
                            </div>
                        </Panel>

                        <div ref={botonesInferioresRef} className="flex justify-content-between align-items-center mt-4 mb-4 px-1 w-full" style={{ minHeight: '50px' }}>

                            <div style={{ width: '150px', textAlign: 'left' }}>
                                {activeIndex > 0 && (
                                    <Button label="Anterior" icon="pi pi-chevron-left" type="button" onClick={handlePrevSeccion} className="p-button-outlined p-button-secondary" />
                                )}
                            </div>

                            <div className="flex-grow-1 text-center">
                                {isReadOnly ? (
                                    <Button label="Anexos" icon="pi pi-copy" title="Ver Anexos" type="button" className="p-button-warning" onClick={subirReporte} />
                                ) : (
                                    generic.buttonsFormsReports(
                                        () => { },
                                        generarReporte,
                                        subirReporte,
                                        enviar,
                                        isSaving || loadReport,
                                        certId != null,
                                        true,
                                        true
                                    )
                                )}
                            </div>
                            <div style={{ width: '150px' }}></div>
                        </div>
                    </TabPanel>
                </TabView>
            </form>

            {mostrarNavFlotante && (
                <div className="flex gap-2 fadein scalein" style={{ position: 'fixed', bottom: '20px', right: '30px', zIndex: 999 }}>

                    {activeIndex > 0 && (
                        <Button icon="pi pi-chevron-left" type="button" onClick={handlePrevSeccion} rounded className="p-button-secondary p-button-outlined shadow-4" style={{ width: '45px', height: '45px', backgroundColor: '#fff' }} tooltip="Anterior" tooltipOptions={{ position: 'left' }} />
                    )}

                    {activeIndex === 0 && (
                        isReadOnly ? (
                            <Button icon="pi pi-chevron-right" type="button" onClick={handleNextSeccion} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Siguiente" tooltipOptions={{ position: 'left' }} />
                        ) : (
                            <Button form="form-certificacion-sociedad" icon={isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-chevron-right'} type="submit" disabled={isSaving} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Guardar y Siguiente" tooltipOptions={{ position: 'left' }} />
                        )
                    )}

                    {activeIndex === 1 && certId && (
                        <>
                            {!isReadOnly && (
                                <Button icon={loadReport ? 'pi pi-spin pi-spinner' : 'pi pi-print'} type="button" onClick={generarReporte} disabled={loadReport} rounded className="p-button-warning shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Formulario" tooltipOptions={{ position: 'left' }} />
                            )}
                            <Button icon="pi pi-copy" type="button" onClick={subirReporte} rounded className="p-button-warning shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Anexos" tooltipOptions={{ position: 'left' }} />
                            {!isReadOnly && (
                                <Button icon="pi pi-send" type="button" onClick={enviar} rounded className="p-button-warning shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Enviar" tooltipOptions={{ position: 'left' }} />
                            )}
                        </>
                    )}
                    {activeIndex === 1 && !isReadOnly && (
                        <Button form="form-certificacion-sociedad" icon={isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-save'} type="submit" disabled={isSaving} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Guardar" tooltipOptions={{ position: 'left' }} />
                    )}
                </div>
            )}

            <Dialog visible={dialogControl} header="Formulario de Auto-certificación - Persona que Ejerce el Control" modal onHide={() => setDialogControl(false)} style={{ width: '95vw', maxWidth: '1100px' }}>
                {/* No conocemos el id de la certificación, por lo que se manda como null, el back lo resuelve a partir del tipo */}
                <Certificacion toast={toast} id={null} idp={certId} permss={permss} catalogos={catalogos} soloLectura={esSoloLectura} tipo={tipo} handlePrev={() => setDialogControl(false)} onEstadoCambiado={(nuevoEstado) => actualizarEstadoBoton(tipo, nuevoEstado)} siCliente={siCliente} />
            </Dialog>

            <Dialog visible={dialogAnexo} header="Gestión de Anexos de Certificación" modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogAnexo(false)} style={{ width: '800px' }}>
                {anexoPendientes && Array.isArray(anexoPendientes) && (
                    <div className="mb-3">
                        <Message severity="warn" text="No se puede enviar el formulario. Faltan los siguientes documentos obligatorios:" className="w-full justify-content-start mb-2" />
                        <ul style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                            {anexoPendientes.map((doc, index) => (
                                <li key={index}>{doc.tipo_adjunto}</li> // Mostramos el nombre del documento que viene de Laravel
                            ))}
                        </ul>
                    </div>
                )}
                <AnexosComponent tipo={"certificacionPj"} urls={urlsAnexos} idp={certId} toast={toast} permss={permss} setDialogSubir={setDialogAnexo} soloLectura={isReadOnly} estado={estadoCertificadoPj} reiniciar={() => { }} />
            </Dialog>
        </>
    );
};
